import React from "react";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import { isNotNullOrUndefined } from "../utils/isNotNullOrUndefined";

function CommonButton({
  padding,
  text,
  onClickHandle,
  white,
  color,
  backgroundColor,
  textColor,
  icon,
  fontSize = "17px",
  borderRadius,
}: {
  padding?: number | string | null;
  text: string;
  onClickHandle?: Function;
  white?: boolean | null;
  color?: string | null;
  textColor?: string;
  backgroundColor?: string;
  icon?: any;
  fontSize?: string;
  borderRadius?: string;
}) {
  const theme = useThemeHook();

  return (
    <div
      onClick={async () => onClickHandle && (await onClickHandle())}
      style={{
        paddingLeft: padding ?? 0,
        paddingRight: padding ?? 0,
        width: "100%",
      }}
    >
      <button
        style={{
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: borderRadius || "30px",
          width: "100%",
          padding: "1.2em 1.2em", // Adjusted padding for desktop
          backgroundColor: backgroundColor
            ? backgroundColor
            : THEME_COLORS[theme].inverse_theme,
          gap: isNotNullOrUndefined(icon) ? "5px" : "0",
        }}
      >
        {icon}
        <div style={{ width: "100%" }}>
          <p
            style={{
              maxLines: 1,
              textOverflow: "ellipsis",
              color: textColor ? textColor : THEME_COLORS[theme].full_theme,
              fontSize: fontSize, // Adjusted font size for desktop
              fontWeight: "500",
            }}
          >
            {text}
          </p>
        </div>
      </button>
    </div>
  );
}

export default CommonButton;
